export const SUCCESS_GET_FPS = 'SUCCESS_GET_FPS';
export const FAILED_GET_FPS = 'FAILED_GET_FPS';
export const SUCCESS_GET_FP = 'SUCCESS_GET_FP';
export const FAILED_GET_FP = 'FAILED_GET_FP';
export const SUCCESS_CREATE_FP = 'SUCCESS_CREATE_FP';
export const FAILED_CREATE_FP = 'FAILED_CREATE_FP';
export const SUCCESS_UPDATE_FP = 'SUCCESS_UPDATE_FP';
export const FAILED_UPDATE_FP = 'FAILED_UPDATE_FP';
export const SUCCESS_DELETE_FP = 'SUCCESS_DELETE_FP';
export const FAILED_DELETE_FP = 'FAILED_DELETE_FP';

export const SUCCESS_GET_FP_CARRIERS = 'SUCCESS_GET_FP_CARRIERS';
export const FAILED_GET_FP_CARRIERS = 'FAILED_GET_FP_CARRIERS';
export const SUCCESS_GET_FP_ZONES = 'SUCCESS_GET_FP_ZONES';
export const FAILED_GET_FP_ZONES = 'FAILED_GET_FP_ZONES';
export const SET_LOCAL_FILTER_PAGEITEMCNT = 'SET_LOCAL_FILTER_PAGEITEMCNT';
export const SET_LOCAL_FILTER_PAGEINDEX = 'SET_LOCAL_FILTER_PAGEINDEX';
export const SET_FETCH_ZONES_FLAG = 'SET_FETCH_ZONES_FLAG';
export const SUCCESS_CREATE_FP_CARRIER = 'SUCCESS_CREATE_FP_CARRIER';
export const FAILED_CREATE_FP_CARRIER = 'FAILED_CREATE_FP_CARRIER';
export const SUCCESS_UPDATE_FP_CARRIER = 'SUCCESS_UPDATE_FP_CARRIER';
export const FAILED_UPDATE_FP_CARRIER = 'FAILED_UPDATE_FP_CARRIER';
export const SUCCESS_DELETE_FP_CARRIER = 'SUCCESS_DELETE_FP_CARRIER';
export const FAILED_DELETE_FP_CARRIER = 'FAILED_DELETE_FP_CARRIER';
export const SUCCESS_CREATE_FP_ZONE = 'SUCCESS_CREATE_FP_ZONE';
export const FAILED_CREATE_FP_ZONE = 'FAILED_CREATE_FP_ZONE';
export const SUCCESS_UPDATE_FP_ZONE = 'SUCCESS_UPDATE_FP_ZONE';
export const FAILED_UPDATE_FP_ZONE = 'FAILED_UPDATE_FP_ZONE';
export const SUCCESS_DELETE_FP_ZONE = 'SUCCESS_DELETE_FP_ZONE';
export const FAILED_DELETE_FP_ZONE = 'FAILED_DELETE_FP_ZONE';

export const SUCCESS_GET_FP_STATUSES = 'SUCCESS_GET_FP_STATUSES';
export const FAILED_GET_FP_STATUSES = 'FAILED_GET_DME_STATUSES';
export const SUCCESS_CREATE_FP_STATUS = 'SUCCESS_CREATE_FP_STATUS';
export const FAILED_CREATE_FP_STATUS = 'FAILED_CREATE_DME_STATUS';
export const SUCCESS_UPDATE_FP_STATUS = 'SUCCESS_UPDATE_FP_STATUS';
export const FAILED_UPDATE_FP_STATUS = 'FAILED_UPDATE_DME_STATUS';
export const SUCCESS_DELETE_FP_STATUS = 'SUCCESS_DELETE_FP_STATUS';
export const FAILED_DELETE_FP_STATUS = 'FAILED_DELETE_DME_STATUS';

export const SUCCESS_CHECK_FP_AVAILABILITY = 'SUCCESS_CHECK_FP_AVAILABILITY';
export const FAILED_CHECK_FP_AVAILABILITY = 'FAILED_CHECK_FP_AVAILABILITY';
export const SUCCESS_CHANGE_FP_4_BOOKINGS = 'SUCCESS_CHANGE_FP_4_BOOKINGS';
export const FAILED_CHANGE_FP_4_BOOKINGS = 'FAILED_CHANGE_FP_4_BOOKINGS';



// WEBPACK FOOTER //
// src/state/constants/fpConstants.js